import { render, staticRenderFns } from "./StoriesLine.vue?vue&type=template&id=072feef1&scoped=true&"
import script from "./StoriesLine.vue?vue&type=script&lang=ts&"
export * from "./StoriesLine.vue?vue&type=script&lang=ts&"
import style0 from "./StoriesLine.vue?vue&type=style&index=0&id=072feef1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072feef1",
  null
  
)

export default component.exports